export default "__VITE_ASSET__D_kvR1yP__"